module.exports = __webpack_public_path__ + "img/fQmVWXUY.098a624c.svg";